
import { computed, defineComponent } from 'vue';
import {
	UiButton,
	UiForm,
	UiRadioTabs,
	useForm,
	useToggle
} from '@/ui-kit';
import PhoneNumberSelect from './PhoneNumberSelect.vue';
import { requiredIf } from '@vuelidate/validators';

export default defineComponent({
	name: 'phone-menu-item-dialog',
	emits: ['update'],
	components: {
		PhoneNumberSelect,
		UiForm,
		UiRadioTabs,
		UiButton
	},
	setup(props, { emit }) {
		const { isOpened, toggleOpened } = useToggle();
		const form = useForm(
			{
				type: 3,
				destination: ''
			},
			computed(() => ({
				destination: {
					required: requiredIf(
						(): boolean =>
							isOpened.value &&
							form.formData.type === 1
					)
				}
			}))
		);

		const openDialog = (data: any) => {
			form.resetForm();
			form.fillFormData(data);
			toggleOpened(true);
		};

		const closeDialog = () => {
			toggleOpened(false);
		};

		const submit = () => {
			closeDialog();
			emit(
				'update',
				form.formData.type === 3
					? {
							type: form.formData.type,
							destination: null
					  }
					: form.formData
			);
		};

		return {
			...form,
			submit,
			isOpened,
			openDialog,
			closeDialog
		};
	}
});
